export const REGEX = {
  PHONE: /^[0-9]{9,11}$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

export type ValidationType = 'phone' | 'email';

export const validate = (type: ValidationType, value: string): boolean => {
  if (!value) return false;

  switch (type) {
    case 'phone':
      return REGEX.PHONE.test(value);
    case 'email':
      return REGEX.EMAIL.test(value);
    default:
      return false;
  }
};
